let config = {
  host: 'satisgaranti.com',
  restApi: 'https://api.satisgaranti.com/v1.0/',
  languages: ['tr', 'en' ,'de', 'fr']
};

export default config;